import { Typography } from '@iheartjane/reefer';
import type { Nullable } from '@iheartjane/types';
import { clsx } from 'clsx';

import styles from './specialBadge.module.css';

interface SpecialBadgeProps {
  containerClassName?: string;
  contentClassName?: string;
  label?: Nullable<string>;
}

export const SpecialBadge = ({
  containerClassName,
  contentClassName,
  label,
}: SpecialBadgeProps) => {
  if (!label) {
    return null;
  }

  return (
    <div className={containerClassName}>
      <div className={clsx(styles['specialBadge'], contentClassName)}>
        <Typography color="inherit" variant="body-semibold">
          {label}
        </Typography>
      </div>
    </div>
  );
};
